import { render } from "./ClientUsersTable.vue?vue&type=template&id=82cdeeb4"
import script from "./ClientUsersTable.vue?vue&type=script&lang=js"
export * from "./ClientUsersTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__